import { resources } from "@constants/hardcoded-strings";
import { AXNUIContent, AXNUILayout } from "@iddataweb/idw-common-ui/types";
import { TabTitleWithErrorCount } from "@containers/common/tab-title-with-error-count/tab-title-with-error-count";
import { ErrorAlert } from "@containers/common/error-alert/error-alert";
import { ThemingFormPanelValidationErrors } from "@idw-types/common/validation/common/theming-validation-errors";

export const getThemingFormPanelValidationErrors = (
    isUsingThemedUI: boolean,
    axnuiContent: AXNUIContent,
    axnuiLayout: AXNUILayout
): ThemingFormPanelValidationErrors => {
    let count = 0;
    let formPanelTitleError = null;
    let formPanelLogoError = null;
    let formPanelLogoWidthError = null;
    let formPanelLogoHeightError = null;

    if (isUsingThemedUI) {
        if (axnuiLayout.formPanel?.showFormPanelTitle && !axnuiContent.formPanel.title) {
            count += 1;
            formPanelTitleError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
        }
        if (axnuiLayout.formPanel?.showFormPanelLogo) {
            if (!axnuiLayout.formPanel.formPanelLogoUrl) {
                count += 1;
                formPanelLogoError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert>;
            }

            if (!axnuiLayout.formPanel.formPanelLogoWidth) {
                count += 1;
                formPanelLogoWidthError = <ErrorAlert><span>This field is required. Please enter a valid number for the logo width</span></ErrorAlert>;
            } else if (`${axnuiLayout.formPanel.formPanelLogoWidth}`.includes("-")) {
                count += 1;
                formPanelLogoWidthError = <ErrorAlert><span>The Form Panel Logo Width cannot be negative</span></ErrorAlert>;
            } else if (!/^\d+$/.test(`${axnuiLayout.formPanel.formPanelLogoWidth}`)) {
                count += 1;
                formPanelLogoWidthError = <ErrorAlert><span>Please enter a valid number for the logo width</span></ErrorAlert>;
            }

            if (!axnuiLayout.formPanel.formPanelLogoHeight) {
                count += 1;
                formPanelLogoHeightError = <ErrorAlert><span>This field is required. Please enter a valid number for the logo height</span></ErrorAlert>;
            } else if (`${axnuiLayout.formPanel.formPanelLogoHeight}`.includes("-")) {
                count += 1;
                formPanelLogoHeightError = <ErrorAlert><span>The Form Panel Logo Height cannot be negative</span></ErrorAlert>;
            } else if (!/^\d+$/.test(`${axnuiLayout.formPanel.formPanelLogoHeight}`)) {
                count += 1;
                formPanelLogoHeightError = <ErrorAlert><span>Please enter a valid number for the logo height</span></ErrorAlert>;
            }
        }
    }

    return {
        formPanelTitleError,
        formPanelLogoError,
        formPanelLogoWidthError,
        formPanelLogoHeightError,
        count: count,
        tabTitle: <TabTitleWithErrorCount
            tabName={resources.pages.verificationServiceDetails.tabs.theming.subTabs.formPanel.tabName}
            errorCount={count}
        />
    };
};
